var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurantMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 65,
    viewBox: "0 0 59 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2320_2418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4082 5C10.9736 5 9 6.97361 9 9.40817V41.7347C9 44.1693 10.9736 46.1429 13.4082 46.1429H25.6117L27.662 49.694C28.5103 51.1634 30.6312 51.1634 31.4796 49.694L33.5298 46.1429H45.7347C48.1693 46.1429 50.1429 44.1693 50.1429 41.7347V9.40816C50.1429 6.9736 48.1692 5 45.7347 5H13.4082Z",
    fill: "#FF6A00"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2320_2418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2853 17.0004V25.5718C35.2853 27.1433 36.571 28.429 38.1424 28.429H39.571V38.429C39.571 39.2147 40.2139 39.8576 40.9996 39.8576C41.7853 39.8576 42.4281 39.2147 42.4281 38.429V12.9004C42.4281 11.9718 41.5567 11.2861 40.6567 11.5004C37.571 12.2576 35.2853 14.8718 35.2853 17.0004ZM28.1424 21.2861H25.2853V12.7147C25.2853 11.929 24.6424 11.2861 23.8567 11.2861C23.071 11.2861 22.4282 11.929 22.4282 12.7147V21.2861H19.571V12.7147C19.571 11.929 18.9282 11.2861 18.1424 11.2861C17.3567 11.2861 16.7139 11.929 16.7139 12.7147V21.2861C16.7139 24.4433 19.271 27.0004 22.4282 27.0004V38.429C22.4282 39.2147 23.071 39.8576 23.8567 39.8576C24.6424 39.8576 25.2853 39.2147 25.2853 38.429V27.0004C28.4424 27.0004 30.9996 24.4433 30.9996 21.2861V12.7147C30.9996 11.929 30.3567 11.2861 29.571 11.2861C28.7853 11.2861 28.1424 11.929 28.1424 12.7147V21.2861Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2320_2418",
    x: 0.183673,
    y: 0.591836,
    width: 58.7752,
    height: 65.6327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2320_2418"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2320_2418",
    result: "effect2_dropShadow_2320_2418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2320_2418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2320_2418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2857,
    height: 34.2857,
    fill: "white",
    transform: "translate(12.4287 8.42871)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantMarker);
export default __webpack_public_path__ + "static/media/restaurant_marker.81e278dbcb3850fd60c0fea5c1327178.svg";
export { ForwardRef as ReactComponent };